import {Component, OnInit, ViewChild} from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import { Subscription } from 'rxjs/Subscription';
import {PasswordComponent} from '../shared/password/password.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    @ViewChild(PasswordComponent)
    protected passwordComponent: PasswordComponent;
    public username;
    public password;

    constructor(private authenticationService: AuthenticationService) { }

    ngOnInit() {
    }

    submit() {
        this.authenticationService.authenticate(this.username, this.passwordComponent.password);
        // console.log('username', this.username);
        // console.log('password', this.password);
    }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts